<template>
  <b-modal id="check-final" hide-footer hide-header no-stacking>
    <template v-slot:default="{ hide }">
      <div class="close-button-container">
        <span class="close-button" @click="hide()">&times;</span>
      </div>

      <div class="modal-main-content">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="roshd logo" />
        </div>

        <div class="heading mb-4">
          <h6>بررسی نهایی</h6>
        </div>

        <!-- <form @submit.prevent="boroToo"> -->
        <div class="check-box">
          <div class="check-titr d-flex">
            <span class="titrfinal">نام بسته</span>
            <span class="titrfinal">قیمت (تومان) </span>
            <span class="titrfinal">تعداد</span>
          </div>
          <div class="line"></div>
          <div v-for="(final, index) in buscard" :key="index">
            <div class="check-conten d-flex">
              <span class="datafinal"> {{ final.title }}</span>
              <span class="datafinal">{{`${price(final.final_price)}` }} </span>
              <span class="datafinal">{{ final.quantity }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="check-sum d-flex">
            <span> جمع</span>
            <span>{{ sumPricekamaFinal }} </span>
          </div>
          <div class="check-Tax check-sum d-flex">
            <span> مالیات بر ارزش افزوده</span>
            <span>0 % </span>
          </div>
          <div class="check-Tax check-sum d-flex">
            <span>جمع مبلغ خالص </span>
            <span>{{ sumPurekamaFinal}} </span>
          </div>
        </div>

        <div class="text-center mt-4 mb-2">
          <b-overlay
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block"
          >
            <button class="btn btn-info"
              @click="payConnect(buscard[0].business_id)"
              type="submit"
              ref="button"
            >
              اتصال به درگاه پرداخت
            </button>
          </b-overlay>
        </div>
        <form
          action="http://nabono.com/core/api/bank/payping/index.php"
          method="POST"
        >
          <input type="hidden" name="iid" v-model="redir.iid" />
          <input type="hidden" name="from_platform" value="6" />
          <input type="hidden" name="uid" v-model="buscard[0].user_id" />
          <input type="hidden" name="bid" value="0" />
          <button style="display: none;" ref="submitBtn" @click="submit">SUBMIT</button>
        </form>
        <!-- </form> -->
        <!-- End Form -->
      </div>
      <!-- End Modal Main Content -->
    </template>
  </b-modal>
</template>

<script>
import axios from "@/axios";

export default {
  name: "CheckFinal",
  // mixins: [formErrors, url],
  data() {
    return {
      buscard: [],
      info: [],
      redir: [],
    };
  },
  computed: {
    sumPricekamaFinal(){
      let sumkama=this.info.sumPrice;
      let dis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(sumkama);
      return dis || 0;
    },
    TaxationkamaFinal(){
      let taxkama = this.info.tax;
      let tadis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(taxkama);
      return tadis || 0;

    },
    sumPurekamaFinal(){
      let taxkama = this.info.pure;
      let tadis = new Intl.NumberFormat({
        maximumSignificantDigits: 3,
      }).format(taxkama);
      return tadis || 0;

    },
  },
  methods: {

    price(final_price) {
      let dis = new Intl.NumberFormat("ir-RL", {
        maximumSignificantDigits: 3,
      }).format(final_price);
      return dis;
    },

    async payConnect(bid) {
      console.log("bid:", bid);

      let data = new FormData();
      data.append("business_id_seller", bid);
      data.append("pay_way", 5);

      await axios.post("invoice/user/create_temp.php", data).then((data) => {
        console.log("datapay:" , data.data)
        this.redir = data.data;
      });
      setTimeout(() => {
        this.$refs.submitBtn.click();
      }, 1000);
    },
    submit() {
      console.log("submit");
    },
  },
  mounted() {
    this.$root.$on("finalcheck", (buscard, factorInfo) => {
      this.buscard = buscard;
      console.log("bbbb:", this.buscard);
      this.info = factorInfo;
    });
  },
};
</script>